import React, { useState, useEffect, Children } from 'react';
import { errorMsg, homeUrl, isBlankOrNullString, rearrangeArray, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import {NavbarTop} from '../ui_components/navbar_top';
import { YoutubeVideoDisplay } from '../ui_components/youtube_video_display';
import { LinkUI, LinkUIBasic, LinkUIBlueBold } from '../ui_components/common_links';
import { txb, txbb, txhb, txhbb, txrb } from '../ui_components/text_style_components';
import { ExpandCloseTab } from '../ui_components/common_ui_components';
import { getPremiumPageDiscount, isPremiumUser, isValidDiscount } from '../login/auth_utils';
import { CodeZymPremiumWithMock } from './premium_with_mock_interview';
import { VisitPremiumSection } from './question_page_discount_ui';


function BuyPremiumMotivationSmall1(){
  
  return (
    <div
      className="
        relative mx-3 my-3 mt-4 overflow-hidden rounded-3xl
        border border-blue-100 bg-gradient-to-br from-white via-blue-50/50 to-orange-50/50
        px-4 py-5 text-center shadow-[0_10px_28px_rgba(15,23,42,0.08)]
        sm:mx-6 sm:px-6 sm:py-6 lg:mx-10
      "
    >
      <div className="pointer-events-none absolute -right-20 -top-20 h-44 w-44 rounded-full bg-orange-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-8 h-44 w-44 rounded-full bg-blue-100/60 blur-3xl" />

      <div className="relative flex flex-col items-center">
        <div
          className="
            mb-3 flex h-14 w-14 items-center justify-center rounded-full
            bg-gradient-to-br from-blue-100 to-orange-100 shadow-inner
          "
        >
          <div
            className="
              flex h-10 w-10 items-center justify-center rounded-2xl
              bg-gradient-to-br from-blue-600 to-indigo-600 text-xl text-white shadow-lg
            "
          >
            🔒
          </div>
        </div>

        <div className="text-xl font-bold leading-snug text-gray-800 sm:text-2xl">
          You need to be a Premium Member <br />
          to attempt this question
        </div>

        <div
          className="
            relative mt-5 w-full max-w-2xl rounded-2xl border border-yellow-200
            bg-gradient-to-br from-yellow-50 via-white to-orange-50 px-4 py-4
            font-mono text-gray-900 shadow-sm
          "
        >
          <div className="absolute -right-3 -top-4 text-3xl">⭐</div>

          {LineText1("Practice this Question,", "italic text-sm sm:text-base")}
          {LineText1(
            "You will be Ahead of Other Candidates", 
            "font-semibold text-lg sm:text-xl text-blue-600 tracking-wide"
          )}
          {LineText1("Who Only Watched Video Tutorials", "italic text-sm sm:text-base")}

          {/*
          {LineText("Practicing this question")}
          {LineText("Will give You its in-depth understanding")}
          {LineText("It's better than watching even tens of video tutorials")}
          */} 
        </div>

        <div
          className="
            mt-5 w-full max-w-xl rounded-2xl border border-blue-100
            bg-white/85 px-4 py-4 shadow-sm backdrop-blur
          "
        >
          <VisitPremiumSection />
        </div>
      </div>
    </div>
  );
}

function LineText1(text, className=""){
  if(isBlankOrNullString(text)) return (<span></span>);
  return (
    <div className={`${className} m-1.5`}>
      {text} 
    </div>
  );
}

function BuyPremiumMotivationQuestionsPage(){
    const [premiumPrice, setPremiumPrice] = useState(800);
    useEffect(() => {
        let discount = getPremiumPageDiscount()
        //console.log(discount)
        if(isValidDiscount(discount))
            setPremiumPrice(discount.finalAmount)

    }, []); // empty bracket means there are no dependencies which will make useEffect re run  
  return(
    <div className='flex flex-col justify-center items-center text-center font-mono font-medium text-xl'>
        <br /> <br /><br /><br />
        {LineText("You are here")}
        {LineText("You want to Practice this Question")}
        {LineText("That would be a wise choice")}
        {LineText("One with Long Term Benefits")}

        <div className='text-3xl py-8 text-red-600 font-bold'>
            But </div>
        <div>This is a 
             <LinkUIBlueBold url= "/premium" text="Premium" />  Question </div>    
        {LineText("Buying Premium will cost you Rs "+premiumPrice.toString() +"/- for an Year")}

        <div className='text-3xl py-8 text-red-600 font-bold'>
            More than that </div>

        {LineText("Implementing Code for this or any other question")}
        {LineText(" will take at least 3-4 hours")}
        {LineText("maybe even a day")}
        {LineText("There will be small failures")}
        {LineText("and moments of sadness")}
        {LineText("Your code may fail test cases many times")}
        
        <div className='text-3xl py-8 text-green-600 font-bold'>
        But </div>

        {LineText("Those small failures will lead to")}
        {LineText("an in depth understanding of question")}
        {LineText("watching even hundreds of video tutorials won't match it")}

        <div className='text-3xl py-8 text-green-600 font-bold'>
        Soon,  </div>
        {LineText("The tests will start to pass")}
        {LineText("And you will have the confidence to clear interviews")}

        <div className='text-3xl py-8 text-green-600 font-bold'>
        You </div>
        {LineText("Deserve your dream Job")}
        {LineText("And that dream package")}
        {LineText("And the respect that comes with it")}
        
        <div className='text-2xl pt-6 py-2 text-red-600 font-bold'>
            Don't Overthink</div>

    {LineText("Take the first step")}
        
        <br />

        <a href="/premium"
        className="text-white bg-blue-600
        cursor-pointer px-6 py-4 rounded-full
        hover:bg-blue-700
        hover:underline
        font-medium font-mono">
          Buy Premium    
        </a>
        <br />



        <br /><br /><br /><br />
        <br /><br /><br /><br />
    </div>
  ); 
}

function LineText(text){
 if(isBlankOrNullString(text)) return (<span></span>);
 return (<div className=' font-mono font-normal m-2'>
    {text} 
    
    </div>);
}

export {BuyPremiumMotivationQuestionsPage, BuyPremiumMotivationSmall1}